//C:\xampp\htdocs\pms2\frontend\src\hooks\useCheckout.ts
/*
import { useState } from "react";
import api from "../services/api";
import { SaleItem, SaleResponse } from "../types/sale";
import { toast } from "react-toastify";
import { formatCartForBackend } from "../utils/cart";

interface CheckoutOptions {
  paymentMethod?: string;
  bank?: string | null;
}

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [lastSale, setLastSale] = useState<SaleResponse | null>(null);

  const checkout = async (
    cart: SaleItem[],
    options: CheckoutOptions = { paymentMethod: "cash", bank: null }
  ): Promise<SaleResponse | null> => {
    if (!cart.length) {
      toast.error("Cart is empty");
      return null;
    }

    setLoading(true);
    try {
      const payload = {
        items: formatCartForBackend(cart),
        payment_method: options.paymentMethod || "cash",
        ...(options.paymentMethod === "mobile_money" && options.bank
          ? { bank: options.bank }
          : {}),
      };

      const res = await api.post<SaleResponse>("/sales/pay", payload);
      const saleResponse = res.data;

      setLastSale(saleResponse);

      if (saleResponse.redirect_url) {
        window.location.href = saleResponse.redirect_url;
      } else {
        toast.success(`Sale recorded successfully ✅ Status: ${saleResponse.sale.status}`);
      }

      return saleResponse;
    } catch (err: any) {
      toast.error("Checkout failed. Try again.");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { checkout, loading, lastSale };
}

import { useState } from "react";
import { checkoutSale, CheckoutPayload } from "../services/salesApi";
import { SaleResponse } from "../types/sale";

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<SaleResponse | null>(null);

  const checkout = async (payload: CheckoutPayload) => {
    try {
      setLoading(true);
      setError(null);

      const data = await checkoutSale(payload);
      setResult(data);
      return data;
    } catch (e: any) {
      setError(e.response?.data?.message || "Checkout failed");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { checkout, loading, error, result };
}
*/

//C:\xampp\htdocs\pms2\frontend\src\hooks\useCheckout.ts
/*
import { useState } from "react";
import api from "../services/api";
import { SaleResponse } from "../types/sale";

export interface CheckoutPayload {
  customer_name: string;
  phone: string;
  payment_method: "cash" | "telebirr" | "mobile_banking";
  bank?: string | null;
  items: {
    product_id: number;
    quantity: number;
    price: number;
  }[];
}

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<SaleResponse | null>(null);

  const checkout = async (
    payload: CheckoutPayload
  ): Promise<SaleResponse | null> => {
    setLoading(true);
    setError(null);

    try {
      const res = await api.post<SaleResponse>(
        "/sales/checkout",
        payload
      );

      setResult(res.data);
      return res.data;
    } catch (err: any) {
      setError(
        err.response?.data?.message || "Checkout failed. Please try again."
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    checkout,
    loading,
    error,
    result,
  };
}
*/
// src/hooks/useCheckout.ts
// src/hooks/useCheckout.ts
/*
import { useState } from "react";
import api from "../services/api";
import { CheckoutResponse, PaymentMethod } from "../types/checkout";
import { SaleItem, BackendCartItem } from "../types/sale";

function formatCart(cart: SaleItem[]): BackendCartItem[] {
  return cart.map(i => ({
    product_id: i.product_id,
    quantity: i.quantity,
  }));
}

function isCheckoutResponse(data: any): data is CheckoutResponse {
  return (
    data &&
    data.success === true &&
    typeof data.sale_id === "number" &&
    typeof data.reference === "string"
  );
}

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const checkout = async (
    customerName: string,
    phone: string,
    paymentMethod: PaymentMethod,
    bank: string | null,
    cart: SaleItem[]
  ): Promise<CheckoutResponse> => {
    setLoading(true);
    setError(null);

    const idempotencyKey = crypto.randomUUID();

    try {
      const res = await api.post(
        "/sales/checkout",
        {
          customer_name: customerName,
          phone,
          payment_method: paymentMethod,
          bank,
          items: formatCart(cart),
        },
        {
          headers: {
            "Idempotency-Key": idempotencyKey, // 🔐 CRITICAL
          },
        }
      );

      if (!isCheckoutResponse(res.data)) {
        throw new Error("Invalid checkout contract from server");
      }

      return res.data;
    } catch (err: any) {
      if (!err.response) {
        setError("Network error. Please check your connection.");
      } else if (err.response.status === 422) {
        setError(err.response.data.message ?? "Invalid checkout data");
      } else if (err.response.status === 409) {
        setError("Duplicate checkout request detected.");
      } else {
        setError("Server error. Please retry.");
      }

      throw err; // 🔥 propagate for UI handling
    } finally {
      setLoading(false);
    }
  };

  return { checkout, loading, error };
}
*/
// src/hooks/useCheckout.ts
/*
import { useState } from "react";
import api from "../services/api";
import { CheckoutResponse, PaymentMethod } from "../types/checkout";
import { SaleItem, BackendCartItem } from "../types/sale";

function formatCart(cart: SaleItem[]): BackendCartItem[] {
  return cart.map(item => ({
    product_id: item.product_id,
    quantity: item.quantity,
  }));
}

function isCheckoutResponse(data: unknown): data is CheckoutResponse {
  if (typeof data !== "object" || data === null) return false;
  const d = data as CheckoutResponse;

  return (
    d.success === true &&
    typeof d.sale_id === "number" &&
    typeof d.invoice === "string" &&
    typeof d.amount === "number" &&
    typeof d.reference === "string"
  );
}

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const checkout = async (
    customerName: string,
    phone: string,
    paymentMethod: PaymentMethod,
    bank: string | null,
    cart: SaleItem[]
  ): Promise<CheckoutResponse> => {
    setLoading(true);
    setError(null);

    const idempotencyKey = crypto.randomUUID();

    try {
      const res = await api.post(
        "/sales/checkout",
        {
          customer_name: customerName,
          phone,
          payment_method: paymentMethod,
          bank,
          items: formatCart(cart),
        },
        {
          headers: {
            "Idempotency-Key": idempotencyKey,
          },
        }
      );

      if (!isCheckoutResponse(res.data)) {
        throw new Error("Invalid checkout response contract");
      }

      return res.data;
    } catch (err: any) {
      if (!err.response) {
        setError("Network error. Please check your connection.");
      } else if (err.response.status === 422) {
        setError(err.response.data.message ?? "Invalid checkout data");
      } else if (err.response.status === 409) {
        setError("Duplicate checkout request detected.");
      } else {
        setError("Server error. Please retry.");
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { checkout, loading, error };
}

// src/hooks/useCheckout.ts
import { useState } from "react";
import api from "../services/api";
import { CheckoutResponse, PaymentMethod } from "../types/checkout";
import { SaleItem, BackendCartItem } from "../types/sale";

function formatCart(cart: SaleItem[]): BackendCartItem[] {
  return cart.map(item => ({
    product_id: item.product_id,
    quantity: item.quantity,
  }));
}

function isCheckoutResponse(data: unknown): data is CheckoutResponse {
  if (typeof data !== "object" || data === null) return false;
  const d = data as CheckoutResponse;

  return (
    typeof d.id === "number" &&
    typeof d.invoice_number === "string" &&
    typeof d.customer_name === "string" &&
    typeof d.customer_phone === "string" &&
    typeof d.payment_method === ["cash","telebirr","mobile_banking"].includes(d.payment_method)
    typeof d.status === "string" &&
    typeof d.total_amount === "number" &&
    typeof d.is_final === "boolean" &&
    Array.isArray(d.items) &&
    (d.payment_intent === undefined ||
      (typeof d.payment_intent.id === "number" &&
        typeof d.payment_intent.reference_code === "string" && // ✅ aligned
        typeof d.payment_intent.amount === "number" &&
        typeof d.payment_intent.status === "string" &&
        typeof d.payment_intent.expires_at === "string"))
  );
}



export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const checkout = async (
    customerName: string,
    phone: string,
    paymentMethod: PaymentMethod,
    bank: string | null,
    cart: SaleItem[]
  ): Promise<CheckoutResponse> => {
    setLoading(true);
    setError(null);

    const idempotencyRef = useRef<string | null>(null);

if (!idempotencyRef.current) {
  idempotencyRef.current = crypto.randomUUID();
}


    try {
      const res = await api.post(
        "/sales/checkout",
        {
          customer_name: customerName,
          phone,
          payment_method: paymentMethod,
          bank,
          items: formatCart(cart),
        },
        {
          headers: {
            "Idempotency-Key": idempotencyKey,
          },
        }
      );

      if (!isCheckoutResponse(res.data)) {
        throw new Error("Invalid checkout response contract");
      }

      return res.data;
    } catch (err: any) {
      if (!err.response) {
        setError("Network error. Please check your connection.");
      } else if (err.response.status === 422) {
        setError(err.response.data.message ?? "Invalid checkout data");
      } else if (err.response.status === 409) {
  setError("Duplicate checkout request. Please wait.");
} else {
        setError("Server error. Please retry.");
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { checkout, loading, error };
}
*/




import { useRef, useState } from "react";
import api from "../services/api";
import { CheckoutResponse, PaymentMethod } from "../types/checkout";
import { SaleItem, BackendCartItem } from "../types/sale";

const ALLOWED_METHODS: PaymentMethod[] = [
  "cash",
  "telebirr",
  "mobile_banking",
];

function formatCart(cart: SaleItem[]): BackendCartItem[] {
  return cart.map((item) => ({
    product_id: item.product_id,
    quantity: item.quantity,
  }));
}

function isCheckoutResponse(data: unknown): data is CheckoutResponse {
  if (typeof data !== "object" || data === null) return false;
  const d = data as CheckoutResponse;

  return (
    typeof d.id === "number" &&
    typeof d.invoice_number === "string" &&
    typeof d.customer_name === "string" &&
    typeof d.customer_phone === "string" &&
    ALLOWED_METHODS.includes(d.payment_method) &&
    ["pending", "paid", "failed", "expired"].includes(d.status) &&
    typeof d.total_amount === "number" &&
    typeof d.is_final === "boolean" &&
    Array.isArray(d.items) &&
    (d.payment_intent === undefined ||
      (typeof d.payment_intent.id === "number" &&
        ALLOWED_METHODS.includes(d.payment_intent.method) &&
        typeof d.payment_intent.reference_code === "string" &&
        typeof d.payment_intent.amount === "number" &&
        ["pending", "paid", "failed", "expired"].includes(
          d.payment_intent.status
        ) &&
        typeof d.payment_intent.expires_at === "string"))
  );
}

export function useCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const idempotencyRef = useRef<string | null>(null);

  const checkout = async (
    customerName: string,
    phone: string,
    paymentMethod: PaymentMethod,
    bank: string | null,
    cart: SaleItem[]
  ): Promise<CheckoutResponse> => {
    setLoading(true);
    setError(null);

    if (!idempotencyRef.current) {
      idempotencyRef.current = crypto.randomUUID();
    }

    try {
      const res = await api.post(
        "/sales/checkout",
        {
          customer_name: customerName,
          phone,
          payment_method: paymentMethod,
          bank,
          items: formatCart(cart),
        },
        {
          headers: {
            "Idempotency-Key": idempotencyRef.current,
          },
        }
      );

      if (!isCheckoutResponse(res.data)) {
        throw new Error("Invalid checkout response contract");
      }

      return res.data;
    } catch (err: any) {
      if (!err.response) {
        setError("Network error. Please check your connection.");
      } else if (err.response.status === 422) {
        setError(err.response.data.message ?? "Invalid checkout data.");
      } else if (err.response.status === 409) {
        setError("Duplicate checkout request. Please wait.");
      } else {
        setError("Server error. Please retry.");
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { checkout, loading, error };
}
